import { graphql } from "@/gql";

export const createActivityLogMutation = graphql(`
  mutation CreateActivityLog($input: LogActivityInput!) {
    createActivityLog(input: $input) {
      id
    }
  }
`);
